import { render, staticRenderFns } from "./cHomeCardElement.vue?vue&type=template&id=839de8b8&"
import script from "./cHomeCardElement.vue?vue&type=script&lang=js&"
export * from "./cHomeCardElement.vue?vue&type=script&lang=js&"
import style0 from "./cHomeCardElement.vue?vue&type=style&index=0&id=839de8b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports